import { TimesheetEntry } from '@sdk/timesheets/types/TimesheetEntry';
import { AllBreakTypes, AutomatedBreakType } from '@sdk/settings/types';
import { AutomatedBreaksSettingsUI } from '@sdk/automatedBreaks/types/AutomatedBreaksSettingsUI';

import getAutomatedBreaksSettingsBreakForEntry from '@web/timesheets/CreateTimesheetModal/utils/getAutomatedBreaksSettingsBreakForEntry';

/**
 * Function checks for the break type and if it is one of the automated breaks than
 * it will return entry extended with automated breaks details (like setting sections and `automatedBreakType` field).
 *
 * @param entry
 * @param breakEntryType
 * @param automatedBreaks
 * @returns
 */
const maybeExtendBreakWithAutomatedBreaksDetails = (
  entry: TimesheetEntry,
  breakEntryType: AllBreakTypes,
  automatedBreaks: AutomatedBreaksSettingsUI
) => {
  if (![AllBreakTypes.meal, AllBreakTypes.rest].includes(breakEntryType)) {
    return entry;
  }

  const automatedBreakType: AutomatedBreakType = breakEntryType as unknown as AutomatedBreakType;
  return {
    ...entry,
    automatedBreakType,
    ...getAutomatedBreaksSettingsBreakForEntry(automatedBreaks, automatedBreakType),
  };
};

export default maybeExtendBreakWithAutomatedBreaksDetails;
